import styled from '@emotion/styled';
import { Collapse } from '@mui/material';
import { ReactNode } from 'react';

const PromptContainer = styled.div`
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.black[50]};
    padding: 24px;
    width: 100%;
`;

const PromptText = styled.div`
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0.15px;
    line-height: normal;
`;

interface Props {
    language: string;
    languages: string[];
    primaryTextByLanguage: Record<string, ReactNode>;
    secondaryTextByLanguage?: Record<string, ReactNode>;
    className?: string;
    removeTags?: boolean;
}

export const Prompt = ({ language, languages, primaryTextByLanguage, secondaryTextByLanguage, className, removeTags }: Props) => {
    return (
        <PromptContainer className={className}>
            <PromptText>
                {languages.map(optionLang => {
                    let primaryText = primaryTextByLanguage[optionLang];

                    if (removeTags && typeof primaryText === 'string') {
                        primaryText = primaryText.replace(/<[^>]*>/g, '');
                    }

                    return (
                        <Collapse in={optionLang === language} unmountOnExit timeout="auto" key={optionLang}>
                            {primaryText}

                            {secondaryTextByLanguage && (
                                <>
                                    <br />
                                    <br />
                                    {secondaryTextByLanguage[optionLang]}
                                </>
                            )}
                        </Collapse>
                    );
                })}
            </PromptText>
        </PromptContainer>
    );
};
